export const selectAppLoader = (state: { appLoader: any; }) => state.appLoader.displayAppLoader;
export const selectCurrentSelectedTab = (state: { appLoader: any; }) => state.appLoader.currentSelectedTab;